import { createAction } from 'redux-actions'
import logger from 'utils/logger'
import { types } from 'features/taskPanel/store/types'
import { handleAPIError } from 'features/app/store/actions'
import { findById } from 'features/list/utils'
import { models, utils } from 'gipsy-misc'
import { getCurrentPathName } from 'utils/location'

export const _openPanel = createAction(types.OPEN_PANEL)
export const _openRequestReviewPanel = createAction(types.OPEN_REQUEST_REVIEW_PANEL)
export const _closePanel = createAction(types.CLOSE_PANEL)
export const setPanelItem = createAction(types.SET_PANEL_ITEM)
export const setEditMode = createAction(types.SET_EDIT_MODE)

export const setLoading = createAction(types.SET_PANEL_LOADING)

export const openPanel = (id, initialTask = {}) => async (dispatch, getState, { api }) => {
  let task = models.task(initialTask)
  /* assign to team member if the page is open */
  if (getCurrentPathName().includes('/team') && getState().teamlist.activeTeamMember) {
    const to = Object.assign({}, getState().teamlist.activeTeamMember)
    const watcher = utils.user.computeUserFromSessionUser(getState().session.user)
    watcher.isReviewer = true
    task = models.task({ to: to, watchers: [watcher], ...initialTask })
  }

  if (!id) {
    return dispatch(_openPanel({ item: task }))
  }

  if (process.env.REACT_APP_ELECTRON !== 'true') {
    window.history.pushState(null, '', `${window.location.pathname}?open=${id}`)
  }

  let item = findById(id)
  if (item && utils.task.isReviewTask(item)) {
    item = { ...task, review: item }
  }

  await dispatch(
    _openPanel({
      mode: id ? 'edit' : 'create',
      id,
      item,
      loading: true
    })
  )

  try {
    item = await api.task.get(id)
  } catch (err) {
    logger.error(err)
    dispatch(handleAPIError(err))
    dispatch(_closePanel())
    return
  }
  /* stop here if the taskPanel has been closed before with fetch the task */
  if (!getState().taskPanel.active) {
    return
  }

  /* update taskpanel with fetched task and set loading to false */
  await dispatch(
    _openPanel({
      id,
      item,
      mode: id ? 'edit' : 'create',
      loading: false
    })
  )
}

export const openRequestReviewPanel = () => async (dispatch, getState, { api }) => {
  let reviewRequest = models.reviewrequest()
  /* assign to team member if the page is open */
  if (getState().teamlist.activeTeamMember) {
    const activeTeamMember = Object.assign({}, getState().teamlist.activeTeamMember)
    activeTeamMember.isReviewer = true
    const requestor = utils.user.computeUserFromSessionUser(getState().session.user)
    reviewRequest = models.reviewrequest({ requestor: requestor, watchers: [activeTeamMember] })
  }

  return dispatch(_openRequestReviewPanel({ item: reviewRequest }))
}

export const closePanel = () => async (dispatch, getState, { api }) => {
  if (process.env.REACT_APP_ELECTRON !== 'true') {
    window.history.pushState(null, '', `${window.location.pathname}`)
  }
  dispatch(_closePanel())
}



// WEBPACK FOOTER //
// ./src/features/taskPanel/store/actions.js